<template>
    <template
        v-for="(post, index) in posts"
        :key="post.id">
        <OpinionsListItem
            v-intersect="(isIntersecting: boolean) => onIntersect(isIntersecting, index)"
            class="tw-px-0"
            :post="post" />
        <v-divider
            v-if="post !== posts[posts.length - 1]"
            class="tw-my-5"
            opacity="0.1"></v-divider>
    </template>
</template>

<script setup lang="ts">
    import type { IOpinion } from '@/contentTypes';

    const props = defineProps<{
        posts: IOpinion[];
    }>();

    const emit = defineEmits<{
        (e: 'fetch-more'): void;
    }>();

    function onIntersect(isIntersecting: boolean, index: number) {
        if (isIntersecting && index === props.posts.length - 5) {
            emit('fetch-more');
        }

    }
</script>

<style lang="scss"></style>
